export type SignalZone =
  | "GOLDEN_LONG"
  | "GOLDEN_SHORT"
  | "WATCH_LONG"
  | "WATCH_SHORT"
  | "NEUTRAL";

export interface QuadrantPoint {
  id: string;
  symbol: string;
  interval: string;
  rsi: number;
  score: number;
  zone: SignalZone;
  price: number;
  change24h: number;
  volume24h: number;
  divergenceStrength: number;
  detectedAt: string;
  lastUpdate: string;
}

export function calculateZone(rsi: number, score: number): SignalZone {
  // Golden zones (A+ signals) - requires triple divergence (handled by backend)
  if (rsi < 30 && score >= 80) return "GOLDEN_LONG";
  if (rsi > 70 && score <= -80) return "GOLDEN_SHORT";

  // Watch zones (A/B signals)
  if (rsi < 40 && score >= 50) return "WATCH_LONG";
  if (rsi > 60 && score <= -50) return "WATCH_SHORT";

  return "NEUTRAL";
}

export function getZoneColor(zone: SignalZone): string {
  switch (zone) {
    case "GOLDEN_LONG":
      return "#22c55e"; // green-500
    case "GOLDEN_SHORT":
      return "#ef4444"; // red-500
    case "WATCH_LONG":
      return "#3b82f6"; // blue-500
    case "WATCH_SHORT":
      return "#f59e0b"; // amber-500
    default:
      return "#9ca3af"; // gray-400
  }
}

// Returns the translation key for zone label - use with t() in components
export function getZoneLabelKey(zone: SignalZone): string {
  switch (zone) {
    case "GOLDEN_LONG":
      return "zones.goldenLong";
    case "GOLDEN_SHORT":
      return "zones.goldenShort";
    case "WATCH_LONG":
      return "zones.watchLong";
    case "WATCH_SHORT":
      return "zones.watchShort";
    default:
      return "zones.neutral";
  }
}

// Returns the translation key for zone description - use with t() in components
export function getZoneDescKey(zone: SignalZone): string {
  switch (zone) {
    case "GOLDEN_LONG":
      return "zones.goldenLongDesc";
    case "GOLDEN_SHORT":
      return "zones.goldenShortDesc";
    case "WATCH_LONG":
      return "zones.watchLongDesc";
    case "WATCH_SHORT":
      return "zones.watchShortDesc";
    default:
      return "zones.neutralDesc";
  }
}
